var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 20",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.5,5h-9C3.224,5,3,4.776,3,4.5v-2C3,2.224,3.224,2,3.5,2H5V1.5C5,1.224,5.224,1,5.5,1h5C10.776,1,11,1.224,11,1.5V2    l1.5,0C12.776,2,13,2.224,13,2.5v2C13,4.776,12.776,5,12.5,5z M4,4h8V3h-1c-0.552,0-1-0.449-1-1H6c0,0.551-0.449,1-1,1H4V4z     M10.5,2L11,2v0H10.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5,15h-7C4.224,15,4,14.776,4,14.5v-10C4,4.224,4.224,4,4.5,4S5,4.224,5,4.5V14h6V4.5C11,4.224,11.224,4,11.5,4    S12,4.224,12,4.5v10C12,14.776,11.776,15,11.5,15z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 7,
    width: 1,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 7,
    width: 1,
    height: 5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.79524cae8dbcb61eab31119ea24ea205.svg";
export { ForwardRef as ReactComponent };